/** 
version=0.12
如何设置页面逻辑，请查阅文档: http://www.wware.org/wide/indexw3c.html
**/

(function() {

  function event_init($) { //这里开始事件处理过程定义。
    /*INSBEGIN:EVENTINIT*/

    /*INSEND:EVENTINIT*/
  } //到这里事件处理过程定义结束。

  function binding_init($) { //这里开始复合数据定义。复合数据意味着，数据自身是凭空计算出来。
    return /*INSBEGIN:COMPUTED*/ {

    } /*INSEND:COMPUTED*/ ;
  } //到这里复合数据定义结束。

  function subscribe_init($) { //这里开始响应数据变化的过程定义。
     return /*INSBEGIN:SUBSCRIBE*/ {
       
     } /*INSEND:SUBSCRIBE*/ ;
  } //到这里响应数据变化的过程定义结束。

  function named_functions($) { //这里开始命名函数的定义。
    return /*INSBEGIN:NAMEDFUNC*/ {
      
    } /*INSEND:NAMEDFUNC*/ ;
  }//到这里命名函数的定义结束。


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //下方代码自动生成，如不清晰，请勿修改
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  requirejs.config(
    /*INSPOINTBEGIN:REQUIREJS_CFG*/
    {
      "baseUrl": "/",
      "paths": {
        "jquery": "libs/jquery/dist/jquery.min",
        "css": 'libs/require-css/css.min',
        "image": 'libs/requirejs-plugins/src/image',
        "spin": "libs/spin.js/spin.min",
        "blockui": "libs/blockui/jquery.blockUI.min",
        "bootstrap": "libs/bootstrap/dist/js/bootstrap.min",
        "notifyjs": "libs/notifyjs/dist/notify-combined.min"
      },
      "shim": {
        "underscore": {
          "exports": "_"
        },
        "bootstrap": {
          "deps": ["jquery"]
        },
        "notifyjs": {
          "deps": ["jquery"]
        }
      }
    }
    /*INSPOINTEND:REQUIREJS_CFG*/
  );

  require(['jquery', "bootstrap", "libs/wware/wwclass.min"],
    function($, bootstrap, wwclass) {

      window.jQuery = window.$ = $;

      $.wwPageconfig = /*INSPOINTEBEGIN:PAGECONFIG*/ {}
        /*INSPOINTEEND:PAGECONFIG*/
      ;

      $().ready(function() {

        if (!$.wwclass) {
          $.wwcbi = binding_init();
          $.wwnf = named_functions();
          $.wwst = subscribe_init();
          wwclass.init($);
        }

        $.wwclass.process($("body"));

        event_init($);
      });
    });
})();
